export function runAtLeast<Type>(ms: number, promise: Promise<Type>): Promise<Type> {
  const timeoutPromise: Promise<undefined> = new Promise((resolve) => setTimeout(resolve, ms));
  return Promise.all([promise, timeoutPromise]).then(([result]: [Type, undefined]) => result);
}
